import apiEndpoints from "../api/api-endpoints"

export const getReactParameters = (target = apiEndpoints.apiAlayaUrl) => {
    return {
        target,
        eval: "setReactParameters()",
        thisPage: true,
    }
}
